import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import Mainlayout from "../layouts/mainLayout";
import AdminLayout from "../layouts/adminLayout";

const PublicRoute = ({
  isAuthenticated,
  component: Component,
  hideFooter,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) => {
        if (rest.fulllayout) {
          return (
            <Mainlayout hideFooter={hideFooter}>
              <Component {...props} />{" "}
            </Mainlayout>
          );
        } 
        else if(rest.noLayout){
          return(
            <Component {...props} />

          )
        }
        else {
          return (
            <AdminLayout>
              <Component {...props} />{" "}
            </AdminLayout>
          );
        }
      }}
    />
  );
};

const mapStateToProps = (state) => {
  const isAuthenticated = state.login.loginFlag;
  return { isAuthenticated };
};

export default connect(mapStateToProps)(PublicRoute);
